import React from 'react';

import { Meta } from '$partials/global';
import * as Pages from './union';
import Header from '$partials/global/header';
import Footer from '$partials/global/footer';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').UnionPage}
 */
const UnionPage = (props) => {
    if (!props.data?.page?.__typename || typeof (Pages[props.data?.page?.__typename]) === 'undefined') {
        return null;
    }
    const navigation = props.data?.navigation || {};
    const footer = props.data?.footer || {};
    const signate = props.data?.signate || {};
    const hasHeroImage = (props.data?.page?.heroImage || props.data?.page?.heroVideo);

    const propertyListing = props.data?.propertyListing;
    const rentalPropertyListing = props.data?.rentalPropertyListing;

    const Component = Pages[props.data?.page?.__typename];

    return (
        <>
            <Meta
                description={props.data?.page?.searchDescription || props.data?.page?.listingText}
                domain={props.domain}
                image={props.data?.page?.listingImage}
                page={props.data?.page}
                title='Russell Simpson'/>
            {props.data?.page?.__typename !== 'Home' && props.data?.page?.__typename !== 'PartnershipLandingPage' && (
                <Header
                    hasHeroImage={!!hasHeroImage}
                    pageType={props.data?.page?.__typename}
                    propertyListing={propertyListing}
                    rentalPropertyListing={rentalPropertyListing}
                    signate={signate?.signate}
                    {...navigation}/>
            )}
            <Component { ...props } />
            <Footer
                {...footer}
                hubspot={props.hubspot}
                page={props.data.page}
                signate={signate?.signate}/>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default UnionPage;
